/**
 * ? @description : Modal Component for View and Edit Data
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { Button,  Table } from "react-bootstrap";
import { Tooltip, Typography, Box, IconButton, Tab, Modal } from "@mui/material";
import { useDispatch,useSelector } from "react-redux";
import { Close } from "@mui/icons-material";

// Axios Component
import Axios from "../../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../../redux/features/appSlice";
import { ShowFullText } from "../../../../Reusable/ShowMoreText";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import axios from "axios";
import dayjs from "dayjs";

function TeacherModalOpen(props) {
  // * Redux
  const dispatch = useDispatch();
  const {access_token} = useSelector((data)=>data.user.user)
  // * State Variable
  const [teacher, setTeacher] = useState([]);
  const [buttonValue, setButtonValue] = useState(false);
  const [dataValidate, setDataValidate] = useState({      /*added by ramanan*/
    isNameError: false,
    isEmailError: false,
    isContactError: false,
    isRefNameError: false,
    isRefNumberError: false,
    isCityError:false 
  })
  const [inputValueChange, setInputValueChange] = useState(true);
  const [studentLevelInfo, setStudentLevelInfo] = useState([]);
  // const [teacherBatchListDetails, setTeacherBatchListDetails] = useState([]);
  const [editedTeacherData, setEditedTeacherData] = useState({
    teacher_name: "",
    email: "",
    contactno: "",
    spoke_lang_1: "",
    spoke_lang_2: "",
    spoke_lang_3: "",
    spoke_lang_4: "",
    spoke_lang_5: "",
    spoke_lang_6: "",
    tentative_start_date: "",
    teacher_status: "",
    // is_apr_residing: "",
    // apr_homeaddress: "",
    // apr_reference_name: "",
    // apr_reference_contact: "",
    // parent_contactno: "",
    // address: "",
    // pincode: "",
     city: "",
    // country: "",
  });
  const [tabValue, setTabValue] = useState("1")
  // * Data Initialization
  var id = props.tabledata[0];

  // * Function Call
  useEffect(() => {
    // ? Get Method : Fetch Data From Server 
    const controller = axios.CancelToken.source();
    (async () => {
      if (id !== undefined) {
        try {
          let options = {
            method: "GET",
            url: `/teacher/${id}`,
            auth: true,
            data: null,
            token:{cancelToken: controller.token}
          };
          let response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token,
          );

          if (response.status === 200) {
            setTeacher(response.data);
          }
        } catch (error) {
          if(!axios.isCancel(error)){
            dispatch(
              showSnackbar({
                message: "Unable to get teacher information.",
                severity: "error",
              })
            ); }
        }
      }
    })()
    return () => {
      controller.cancel();
  }
  }, [id, dispatch,props.show]);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: "800px",
    bgcolor: 'background.paper',
    borderRadius: 3,
    boxShadow: 24,
    p: 4,
  };

  // * Assign Teacher Data to State Variable ( editedTeacherData )
  useEffect(() => {
    if (teacher.length > 0) {
      setEditedTeacherData(prev => ({
        ...prev,
        teacher_name: teacher[0].teacher_name,
        email: teacher[0].email,
        contactno: teacher[0].contactno,
        spoke_lang_1: teacher[0].spoke_lang_1,
        spoke_lang_2: teacher[0].spoke_lang_2,
        spoke_lang_3: teacher[0].spoke_lang_3,
        spoke_lang_4: teacher[0].spoke_lang_4,
        spoke_lang_5: teacher[0].spoke_lang_5,
        spoke_lang_6: teacher[0].spoke_lang_6,
        tentative_start_date: teacher[0].tentative_start_date,
        teacher_status: teacher[0].teacher_status,
        is_apr_residing: teacher[0].is_apr_residing,
        apr_homeaddress: teacher[0].apr_homeaddress,
        apr_reference_name: teacher[0].apr_reference_name,
        apr_reference_contact: teacher[0].apr_reference_contact,
        city:teacher[0].city,
        // parent_contactno: teacher[0].parent_contactno,
        // address: teacher[0].address,
        // pincode: teacher[0].pincode,
        // city: teacher[0].city,
        // country: teacher[0].country,
      }));
    }
  }, [teacher]);

  // console.log(editedTeacherData,'editedTeacherData');

  // ? Put Method : Update Teacher Data
  const putTeacherDataById = async () => {
    try {
      if (teacher[0].teacher_mapped_status === "mapped" && editedTeacherData.teacher_status !== "active") {
        dispatch(
          showSnackbar({
            // message: "Teacher is mapped to a student. Please unmap the Group.",
            message:"Teacher is mapped to a student. Please unmap the student teacher combination and map the students to a different teacher",
            severity: "error",
          })
        );
        return; 
      }

 
        let options = {
          method: "PUT",
          url: `/teacher/updatefields/${id}`,
          auth: true,
          data: editedTeacherData,
        };
  
        let response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data
        );
  
        if (response.status === 200) {
          setButtonValue(false);
          setInputValueChange(true);
          props.onHide();
          props.onCloseCallback();
          // console.log(response)
          // window.location.reload();
          dispatch(
            showSnackbar({
              message: "Teacher data updated successfully !!",
              severity: "success",
            })
          );
        } else if (response.status === 202) {
          setButtonValue(false);
          setInputValueChange(true);
          // props.onHide();
          // console.log(response.data.message)
          // window.location.reload();
          dispatch(
            showSnackbar({
              message: response.data.message,
              severity: "error",
            })
          );
        }
   

    } catch (error) {
      dispatch(
        showSnackbar({
          message: "Error occurred while updating teacher profile.",
          severity: "error",
        })
      );
    }
  };

  useEffect(() => {
    const controller = axios.CancelToken.source();
    (async () => {
      if (id !== undefined) {
        try {
          let options = {
            method: "GET",
            url: `teacher/get/mapped_student_level_details/${id}`,
            auth: true,
            data: null,
            token:{cancelToken: controller.token}
          };

          let { data } = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token,
          );


          if (typeof data.result_status1 === "object") {
            let studentStatus = data.result_status1.map(result => {
              let index = data.result_status2.findIndex(find => find.level_id === result.current_level_id);

              // return data.result_status2[index] !== -1 ? 
              //   {...result, level_name : data.result_status2[index].level_name} :
              //   {...result, level_name : "Not assigned"}

              return {
                ...result,
                level_name: index !== -1 ? data.result_status2[index].level_name : "Not assigned"
              }
            });
            // console.log(studentStatus);
            setStudentLevelInfo(studentStatus);
          } else {
            setStudentLevelInfo([]);
          }

        } catch (error) {
          if(!axios.isCancel(error)) { console.log(error);
            dispatch(
              showSnackbar({
                message: "Unable to get mapped to students information.",
                severity: "error",
              })
            );}
        }
      }
    })();
    return () => {
      controller.cancel();
  }
  }, [id, dispatch]);

  //To get batchlist info for teachers
  useEffect(() => {
    const controller = axios.CancelToken.source();
    (async () => {
      if (id !== undefined) {
        try {
          // let options = {
          //   method: "GET",
          //   url: `teacher/get/batchlist/teacher/${id}`,
          //   auth: true,
          //   data: null,
          //   token:{cancelToken: controller.token}
          // };

          // let { data } = await Axios(
          //   options.method,
          //   options.url,
          //   options.auth,
          //   options.data,
          //   options.token,
          //   );

          // console.log(data);
          // setTeacherBatchListDetails(data);
        } catch (error) {
          if(!axios.isCancel){
            console.log(error);
            dispatch(
              showSnackbar({
                message: "Unable to get batch list information.",
                severity: "error",
              })
            );}
        }
      }
    })();
    
    return () => {
      controller.cancel();
  }
  }, [id, dispatch])

  /*Added by Ramanan : Form Validation function*/
  function validateEditedTeacherData(input, type) {
    switch (type) {
      case "email":
        return !/[a-z0-9]+@/.test(input) ? setDataValidate(prevData => {
          return { ...prevData, isEmailError: true }
        }) : setDataValidate(prevData => {
          return { ...prevData, isEmailError: false }
        });
      case "name":
        return input.length < 2 ? setDataValidate(prevData => {
          return { ...prevData, isNameError: true }
        }) : setDataValidate(prevData => {
          return { ...prevData, isNameError: false }
        });
      case "contactno":
        return input.length !== 10 ? setDataValidate(prevData => {
          return { ...prevData, isContactError: true }
        }) : setDataValidate(prevData => {
          return { ...prevData, isContactError: false }
        });
      // case "aprreferencename":
      //   return input.length < 2 ? setDataValidate(prevData => {
      //     return { ...prevData, isRefNameError: true }
      //   }) : setDataValidate(prevData => {
      //     return { ...prevData, isRefNameError: false }
      //   });
      // case "aprreferencenumber":
      //   return input.length !== 10 ? setDataValidate(prevData => {
      //     return { ...prevData, isRefNumberError: true }
      //   }) : setDataValidate(prevData => {
      //     return { ...prevData, isRefNumberError: false }
      //   });
        case "city":
        return input.length === '' ? setDataValidate(prevData => {
          return { ...prevData, isCityError: true }
        }) : setDataValidate(prevData => {
          return { ...prevData, isCityError: false }
        });
      default:
        break;
    }
  }

  const closeCard = () => {
    props.onHide()
    setButtonValue(false);
    setInputValueChange(true);
    setDataValidate(
      {     
    isNameError: false,
    isEmailError: false,
    isContactError: false,
    isRefNameError: false,
    isRefNumberError: false,
    isCityError:false
  }
    )
  }

  const registerDate = dayjs(teacher[0]?.tcreated_at).format("DD-MM-YYYY")

  return (
    teacher.length > 0 && (
      <Modal
        open={props.show}
        onClose={closeCard}
      >
        <Box sx={style}>
          <TabContext value={tabValue}>
             <Box sx={{display: "flex", alignItems: "center"}}>
             <h5>
              Teacher Information&nbsp;&nbsp;
              <Tooltip
                arrow
                title="Edit Teacher Information"
                placement="bottom"
              >
                <span
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  onClick={() => {
                    setButtonValue(!buttonValue);
                    setInputValueChange(!inputValueChange);
                  }}
                >
                  <i className="bi bi-pencil-fill"></i>
                </span>
              </Tooltip>
            </h5>
             </Box>
            <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
              <TabList
                value={tabValue}
                onChange={(e, newValue) => setTabValue(newValue)}
              >
                <Tab label="Primary" value="1" />
                <Tab label="Students" value="2" />
                <Tab label="Residence Information" value="3" />
                <Tab label="Other Information" value="4" />
              </TabList>
              <IconButton onClick={closeCard}>
                <Close />
              </IconButton>
            </Box>

            <TabPanel value="1">
            <div className="d-flex justify-content-start">
                <div style={{display:"flex", flexDirection:"column", gap:"4.1px"}}>
                  <div style={{ display: "none", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Unique Id :</p>
                    {/* <input type="text" value={teacher[0].teacher_id} disabled /> */}
                    <strong>{teacher[0].teacher_id}</strong>
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Batch Name :</p>
                    <strong>{teacher[0].group_name}</strong>
                  </div>
                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>
                      Name <span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      value={editedTeacherData.teacher_name}
                      onChange={(e) => {
                        validateEditedTeacherData(e.target.value, "name");
                        setEditedTeacherData({
                          ...editedTeacherData,
                          teacher_name: e.target.value,
                        })
                      }

                      }
                      disabled={inputValueChange}
                    />
                  </div>
                  {<p style={{ color: "red", marginLeft: "150px" }}>{dataValidate.isNameError && "Please Enter valid name"}</p>}
                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>
                      E-mail <span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      value={editedTeacherData.email}
                      onChange={(e) => {
                        validateEditedTeacherData(e.target.value, "email");
                        setEditedTeacherData({
                          ...editedTeacherData,
                          email: e.target.value,
                        })
                      }
                      }
                      disabled={inputValueChange}
                    />
                  </div>
                  <p style={{ color: "red", marginLeft: "150px" }}>{dataValidate.isEmailError && "Please Enter a valid Email"}</p>
                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>
                      Mobile <span style={{ color: "red" }}>*</span>
                    </p>
                    <input
                      type="text"
                      value={editedTeacherData.contactno}
                      onChange={(e) => {
                        validateEditedTeacherData(e.target.value, "contactno");
                        setEditedTeacherData({
                          ...editedTeacherData,
                          contactno: e.target.value,
                        })
                      }
                      }
                      disabled={inputValueChange}
                    />
                  </div>
                  <p style={{ color: "red", marginLeft: "150px" }}>{dataValidate.isContactError && "Mobile number must contain 10 digit"}</p>
                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Registered Date :</p>
                    <input
                      type="text"
                      value={registerDate}
                      disabled
                    />
                  </div>
                </div>

                <div className="mx-5" style={{ display:"flex", flexDirection:"column", justifyContent: "space-between"}}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>
                      Language 1 <span style={{ color: "red" }}>*</span>
                    </p>

                    <select
                      type="text"
                      style={{ width: 175 }}
                      value={editedTeacherData.spoke_lang_1}
                      onChange={(e) =>
                        setEditedTeacherData({
                          ...editedTeacherData,
                          spoke_lang_1: e.target.value,
                        })
                      }
                      disabled={inputValueChange}
                    >
                      {/* <option value="">Select One Language</option> */}
                      <option value="Tamil">Tamil</option>
                      <option value="Malayalam">Malayalam</option>
                      <option value="Kannada">Kannada</option>
                      <option value="Telugu">Telugu</option>
                      <option value="Marathi">Marathi</option>
                      <option value="Hindi">Hindi</option>
                      <option value="Urudu">Urudu</option>
                      <option value="English">English</option>
                    </select>
                  </div>

                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Language 2 :</p>

                    <select
                      type="text"
                      style={{ width: 175 }}
                      value={editedTeacherData.spoke_lang_2}
                      onChange={(e) => {
                        setEditedTeacherData({
                          ...editedTeacherData,
                          spoke_lang_2: e.target.value,
                        });
                      }}
                      disabled={inputValueChange}
                    >
                      <option value="">Select One Language</option>
                      <option value="Tamil">Tamil</option>
                      <option value="Malayalam">Malayalam</option>
                      <option value="Kannada">Kannada</option>
                      <option value="Telugu">Telugu</option>
                      <option value="Marathi">Marathi</option>
                      <option value="Hindi">Hindi</option>
                      <option value="Urudu">Urudu</option>
                      <option value="English">English</option>
                    </select>
                  </div>

                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Language 3 :</p>

                    <select
                      type="text"
                      style={{ width: 175 }}
                      value={editedTeacherData.spoke_lang_3}
                      onChange={(e) => {
                        setEditedTeacherData({
                          ...editedTeacherData,
                          spoke_lang_3: e.target.value,
                        });
                      }}
                      disabled={inputValueChange}
                    >
                      <option value="">Select One Language</option>
                      <option value="Tamil">Tamil</option>
                      <option value="Malayalam">Malayalam</option>
                      <option value="Kannada">Kannada</option>
                      <option value="Telugu">Telugu</option>
                      <option value="Marathi">Marathi</option>
                      <option value="Hindi">Hindi</option>
                      <option value="Urudu">Urudu</option>
                      <option value="English">English</option>
                    </select>
                  </div>

                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Language 4 :</p>

                    <select
                      type="text"
                      style={{ width: 175 }}
                      value={editedTeacherData.spoke_lang_4}
                      onChange={(e) => {
                        setEditedTeacherData({
                          ...editedTeacherData,
                          spoke_lang_4: e.target.value,
                        });
                      }}
                      disabled={inputValueChange}
                    >
                      <option value="">Select One Language</option>
                      <option value="Tamil">Tamil</option>
                      <option value="Malayalam">Malayalam</option>
                      <option value="Kannada">Kannada</option>
                      <option value="Telugu">Telugu</option>
                      <option value="Marathi">Marathi</option>
                      <option value="Hindi">Hindi</option>
                      <option value="Urudu">Urudu</option>
                      <option value="English">English</option>
                    </select>
                  </div>

                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Language 5 :</p>

                    <select
                      type="text"
                      style={{ width: 175 }}
                      value={editedTeacherData.spoke_lang_5}
                      onChange={(e) => {
                        setEditedTeacherData({
                          ...editedTeacherData,
                          spoke_lang_5: e.target.value,
                        });
                      }}
                      disabled={inputValueChange}
                    >
                      <option value="">Select One Language</option>
                      <option value="Tamil">Tamil</option>
                      <option value="Malayalam">Malayalam</option>
                      <option value="Kannada">Kannada</option>
                      <option value="Telugu">Telugu</option>
                      <option value="Marathi">Marathi</option>
                      <option value="Hindi">Hindi</option>
                      <option value="Urudu">Urudu</option>
                      <option value="English">English</option>
                    </select>
                  </div>

                  <br />

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Language 6 :</p>

                    <select
                      type="text"
                      style={{ width: 175 }}
                      value={editedTeacherData.spoke_lang_6}
                      onChange={(e) => {
                        setEditedTeacherData({
                          ...editedTeacherData,
                          spoke_lang_6: e.target.value,
                        });
                      }}
                      disabled={inputValueChange}
                    >
                      <option value="">Select One Language</option>
                      <option value="Tamil">Tamil</option>
                      <option value="Malayalam">Malayalam</option>
                      <option value="Kannada">Kannada</option>
                      <option value="Telugu">Telugu</option>
                      <option value="Marathi">Marathi</option>
                      <option value="Hindi">Hindi</option>
                      <option value="Urudu">Urudu</option>
                      <option value="English">English</option>
                    </select>
                  </div>
                </div>
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Role :</p>
                    <strong>{teacher[0].role}</strong>
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Comments :</p>
                    <strong
                    // style={{ width: 175 , overflow: 'hidden'}}
                    style={{textAlign: 'center'}}
                    >
                      {/* {teacher[0].note_description} */}
                      <ShowFullText title={teacher[0].note_description}>
                        <Typography variant='p' sx={{ cursor: 'pointer' }}>
                          {teacher[0].note_description && teacher[0].note_description.length > 25 ? `${teacher[0].note_description.substring(0, 25)}...` : teacher[0].note_description}
                        </Typography>
                      </ShowFullText>
                    </strong>
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>
                      Status <span style={{ color: "red" }}>*</span> :
                    </p>

                    <select
                      // style={{ width: "180px" }}
                      value={editedTeacherData.teacher_status}
                      onChange={(e) =>
                        setEditedTeacherData({
                          ...editedTeacherData,
                          teacher_status: e.target.value,
                        })
                      }
                      disabled={inputValueChange}
                    >
                      {/* <option value="">Select One</option> */}
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                      <option value="drop">Drop</option>
                    </select>

                    {/* <input
                      type="text"
                      value={editedTeacherData.teacher_status}
                      onChange={(e) =>
                        setEditedTeacherData({
                          ...editedTeacherData,
                          teacher_status: e.target.value,
                        })
                      }
                      disabled={inputValueChange}
                    /> */}
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Group Status :</p>
                    <strong>{teacher[0].group_status}</strong>
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Mapped Status :</p>
                    <strong>{teacher[0].teacher_mapped_status}</strong>
                  </div>

                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "150px" }}>Audio Status :</p>
                    <strong>{teacher[0].audio_status}</strong>
                  </div>
                </div>
              </div>
            </TabPanel>
           <TabPanel value="2">
           <div className="d-flex flex-column">
              <div>
                  {studentLevelInfo.length > 0 ?
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>Mapped To Students</th>
                          <th>Student's level</th>
                        </tr>
                      </thead>
                      <tbody>
                        {studentLevelInfo.map((levelInfo, index) => {
                          return (
                            <tr key={index}>
                              <td><strong>{levelInfo.student_name}</strong></td>
                              <td>{levelInfo.level_name}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </Table> :
                    <p style={{ display: "flex", justifyContent: "center", color: "red", margin: "50px 0" }}>No Mapped to student info for this teacher</p>
                  }
                </div>

              </div>
           </TabPanel>
           <TabPanel value="3">
           <div style={{display:"flex", flexDirection:"column", gap:"4.1px"}}>
                {/* <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ width: "200px" }}>
                    Residing in APR <span style={{ color: "red" }}>*</span>
                  </p>

                  <select
                    type="text"
                    style={{ width: "175px" }}
                    value={editedTeacherData.is_apr_residing}
                    onChange={(e) =>
                      setEditedTeacherData({
                        ...editedTeacherData,
                        is_apr_residing: e.target.value === "true",

                        apr_homeaddress: !editedTeacherData.is_apr_residing ? teacher[0].apr_homeaddress : "others",
                        apr_reference_name: editedTeacherData.is_apr_residing ? "" : teacher[0].apr_reference_name,
                        apr_reference_contact: editedTeacherData.is_apr_residing ? "" : teacher[0].apr_reference_contact,
                      })
                    }
                    disabled={inputValueChange}
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div> */}
 <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ width: "200px" }}>
                    City of Residence &nbsp; <span style={{ color: "red" }}>*</span>
                  </p>

                 <input
                        type="text"
                        style={{ width: "175px" }}
                        value={editedTeacherData.city}
                        onChange={(e) => {
                          validateEditedTeacherData(e.target.value, "aprreferencename");
                          setEditedTeacherData({
                            ...editedTeacherData,
                            city: e.target.value,
                          })
                        }}
                        disabled={inputValueChange}
                      />
                                         <p style={{ color: "red", marginLeft: "200px" }}>{dataValidate.isRefNameError && "Please enter a valid name"}</p>
 
                </div>
                <br />

                {/* {editedTeacherData.is_apr_residing && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "200px" }}>
                      APR Home Address <span style={{ color: "red" }}>*</span>
                    </p>

                    <select
                      type="text"
                      style={{ width: "175px" }}
                      value={editedTeacherData.apr_homeaddress}
                      onChange={(e) =>
                        setEditedTeacherData({
                          ...editedTeacherData,
                          apr_homeaddress: e.target.value,
                        })
                      }
                      disabled={inputValueChange}
                    >
                      <option value="APR Villas">APR Villas</option>
                      <option value="APR Towers">APR Towers</option>
                    </select>
                  </div>
                )} */}

                {/* {!editedTeacherData.is_apr_residing && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <p style={{ width: "200px" }}>
                      APR Home Address <span style={{ color: "red" }}>*</span>
                    </p>

                    <select
                      type="text"
                      style={{ width: "175px" }}
                      value={editedTeacherData.apr_homeaddress}
                      onChange={(e) =>
                        setEditedTeacherData({
                          ...editedTeacherData,
                          apr_homeaddress: e.target.value,
                        })
                      }
                      disabled={inputValueChange}
                    >
                      <option value="others">Others</option>
                    </select>
                  </div>
                )} */}

                <br />

                {/* {!editedTeacherData.is_apr_residing && (
                  <>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p style={{ width: "200px" }}>APR Reference Name <span style={{ color: "red" }}>*</span></p>

                      <input
                        type="text"
                        style={{ width: "175px" }}
                        value={editedTeacherData.apr_reference_name}
                        onChange={(e) => {
                          validateEditedTeacherData(e.target.value, "aprreferencename");
                          setEditedTeacherData({
                            ...editedTeacherData,
                            apr_reference_name: e.target.value,
                          })
                        }}
                        disabled={inputValueChange}
                      />
                    </div>
                    <p style={{ color: "red", marginLeft: "200px" }}>{dataValidate.isRefNameError && "Please enter a valid name"}</p>
                  </>
                )} */}

                <br />

                {/* {!editedTeacherData.is_apr_residing && (
                  <>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <p style={{ width: "200px" }}>
                        APR Reference Contact{" "}
                        <span style={{ color: "red" }}>*</span>
                      </p>

                      <input
                        type="text"
                        style={{ width: "175px" }}
                        value={editedTeacherData.apr_reference_contact}
                        onChange={(e) => {
                          validateEditedTeacherData(e.target.value, "aprreferencenumber");
                          setEditedTeacherData({
                            ...editedTeacherData,
                            apr_reference_contact: e.target.value,
                          })
                        }}
                        disabled={inputValueChange}
                      />
                    </div>
                    <p style={{ color: "red", marginLeft: "200px" }}>{dataValidate.isRefNumberError && "Mobile number must contain 10 digit"}</p>
                  </>
                )} */}
              </div>
           </TabPanel>
           <TabPanel value="4">
           <div style={{display:"flex", flexDirection:"column", gap:"4.1px"}}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ width: "200px" }}>Already Have Student ? :</p>

                  <strong>
                    {teacher[0]?.have_student_already === true ? "Yes" : "No"}
                  </strong>
                </div>

                <br />

                <div style={{ display: "flex", alignItems: "center" }}>
                  <p style={{ width: "200px" }}>
                    Tentative Start Date <span style={{ color: "red" }}>*</span>
                  </p>

                  <input
                    type="date"
                    style={{ width: "175px" }}
                    value={editedTeacherData?.tentative_start_date?.split("T")[0]}
                    onChange={(e) =>
                      setEditedTeacherData({
                        ...editedTeacherData,
                        tentative_start_date: e.target.value,
                      })
                    }
                    disabled={inputValueChange}
                  />
                </div>
              </div>
           </TabPanel>

           <Box sx={{borderTop: 1, borderColor: "divider", display: "flex", alignItems: "center",}}>
           {buttonValue === false ? (
            <Button style={{marginTop:"1rem"}} variant="primary" onClick={props.onHide}>
              CLOSE
            </Button>
          ) : (
            <div>
              <Button
               style={{marginTop:"1rem"}}
                type="button"
                variant="light"
                className="mx-3"
                onClick={() => { closeCard()}}
              >
                CANCEL
              </Button>

              <Button
              style={{marginTop:"1rem"}}
                type="submit"
                variant="primary"
                disabled={Object.values(dataValidate).some(error => error)}
                onClick={() => putTeacherDataById()}
              >
                SAVE
              </Button>
            </div>
          )}
           </Box>
          </TabContext>

        </Box>

      </Modal>


    )
  );
}

export default TeacherModalOpen;

/*{ <Modal
  {...props}
  size="xl"
  aria-labelledby="contained-modal-title-vcenter"
  centered
>
  <Modal.Header>
    <Modal.Title id="contained-modal-title-vcenter">
      <h5>
        Teacher Information&nbsp;&nbsp;
        <Tooltip
          arrow
          title="Edit Teacher Information"
          placement="bottom"
        >
          <span
            data-bs-toggle="tooltip"
            data-bs-placement="right"
            onClick={() => {
              setButtonValue(true);
              setInputValueChange(false);
            }}
          >
            <i className="bi bi-pencil-fill"></i>
          </span>
        </Tooltip>
      </h5>
    </Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Tabs
      id="uncontrolled-tab-example"
      defaultActiveKey="primary"
      className="mb-3"
    >
      <Tab eventKey="primary" title="Primary">
        <div className="d-flex justify-content-start">
          <div>
            <div style={{ display: "none", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Unique Id :</p>
              {/* <input type="text" value={teacher[0].teacher_id} disabled /> 
              <strong>{teacher[0].teacher_id}</strong>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Batch Name :</p>
              <strong>{teacher[0].group_name}</strong>
            </div>
            <br />

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>
                Name <span style={{ color: "red" }}>*</span>
              </p>
              <input
                type="text"
                value={editedTeacherData.teacher_name}
                onChange={(e) => {
                  validateEditedTeacherData(e.target.value, "name");
                  setEditedTeacherData({
                    ...editedTeacherData,
                    teacher_name: e.target.value,
                  })
                }

                }
                disabled={inputValueChange}
              />
            </div>
            {<p style={{ color: "red", marginLeft: "150px" }}>{dataValidate.isNameError && "Please Enter valid name"}</p>}
            <br />

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>
                E-mail <span style={{ color: "red" }}>*</span>
              </p>
              <input
                type="text"
                value={editedTeacherData.email}
                onChange={(e) => {
                  validateEditedTeacherData(e.target.value, "email");
                  setEditedTeacherData({
                    ...editedTeacherData,
                    email: e.target.value,
                  })
                }
                }
                disabled={inputValueChange}
              />
            </div>
            <p style={{ color: "red", marginLeft: "150px" }}>{dataValidate.isEmailError && "Please Enter a valid Email"}</p>
            <br />

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>
                Mobile <span style={{ color: "red" }}>*</span>
              </p>
              <input
                type="text"
                value={editedTeacherData.contactno}
                onChange={(e) => {
                  validateEditedTeacherData(e.target.value, "contactno");
                  setEditedTeacherData({
                    ...editedTeacherData,
                    contactno: e.target.value,
                  })
                }
                }
                disabled={inputValueChange}
              />
            </div>
            <p style={{ color: "red", marginLeft: "150px" }}>{dataValidate.isContactError && "Mobile number must contain 10 digit"}</p>
            <br />

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Registered Date :</p>
              <input
                type="text"
                value={teacher[0].tcreated_at.split("T")[0]}
                disabled
              />
            </div>
          </div>

          <div className="mx-5">
            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>
                Language 1 <span style={{ color: "red" }}>*</span>
              </p>

              <select
                type="text"
                style={{ width: 175 }}
                value={editedTeacherData.spoke_lang_1}
                onChange={(e) =>
                  setEditedTeacherData({
                    ...editedTeacherData,
                    spoke_lang_1: e.target.value,
                  })
                }
                disabled={inputValueChange}
              >
                {/* <option value="">Select One Language</option> --
                <option value="Tamil">Tamil</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Kannada">Kannada</option>
                <option value="Telugu">Telugu</option>
                <option value="Marathi">Marathi</option>
                <option value="Hindi">Hindi</option>
                <option value="Urudu">Urudu</option>
                <option value="English">English</option>
              </select>
            </div>

            <br />

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Language 2 :</p>

              <select
                type="text"
                style={{ width: 175 }}
                value={editedTeacherData.spoke_lang_2}
                onChange={(e) => {
                  setEditedTeacherData({
                    ...editedTeacherData,
                    spoke_lang_2: e.target.value,
                  });
                }}
                disabled={inputValueChange}
              >
                <option value="">Select One Language</option>
                <option value="Tamil">Tamil</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Kannada">Kannada</option>
                <option value="Telugu">Telugu</option>
                <option value="Marathi">Marathi</option>
                <option value="Hindi">Hindi</option>
                <option value="Urudu">Urudu</option>
                <option value="English">English</option>
              </select>
            </div>

            <br />

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Language 3 :</p>

              <select
                type="text"
                style={{ width: 175 }}
                value={editedTeacherData.spoke_lang_3}
                onChange={(e) => {
                  setEditedTeacherData({
                    ...editedTeacherData,
                    spoke_lang_3: e.target.value,
                  });
                }}
                disabled={inputValueChange}
              >
                <option value="">Select One Language</option>
                <option value="Tamil">Tamil</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Kannada">Kannada</option>
                <option value="Telugu">Telugu</option>
                <option value="Marathi">Marathi</option>
                <option value="Hindi">Hindi</option>
                <option value="Urudu">Urudu</option>
                <option value="English">English</option>
              </select>
            </div>

            <br />

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Language 4 :</p>

              <select
                type="text"
                style={{ width: 175 }}
                value={editedTeacherData.spoke_lang_4}
                onChange={(e) => {
                  setEditedTeacherData({
                    ...editedTeacherData,
                    spoke_lang_4: e.target.value,
                  });
                }}
                disabled={inputValueChange}
              >
                <option value="">Select One Language</option>
                <option value="Tamil">Tamil</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Kannada">Kannada</option>
                <option value="Telugu">Telugu</option>
                <option value="Marathi">Marathi</option>
                <option value="Hindi">Hindi</option>
                <option value="Urudu">Urudu</option>
                <option value="English">English</option>
              </select>
            </div>

            <br />

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Language 5 :</p>

              <select
                type="text"
                style={{ width: 175 }}
                value={editedTeacherData.spoke_lang_5}
                onChange={(e) => {
                  setEditedTeacherData({
                    ...editedTeacherData,
                    spoke_lang_5: e.target.value,
                  });
                }}
                disabled={inputValueChange}
              >
                <option value="">Select One Language</option>
                <option value="Tamil">Tamil</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Kannada">Kannada</option>
                <option value="Telugu">Telugu</option>
                <option value="Marathi">Marathi</option>
                <option value="Hindi">Hindi</option>
                <option value="Urudu">Urudu</option>
                <option value="English">English</option>
              </select>
            </div>

            <br />

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Language 6 :</p>

              <select
                type="text"
                style={{ width: 175 }}
                value={editedTeacherData.spoke_lang_6}
                onChange={(e) => {
                  setEditedTeacherData({
                    ...editedTeacherData,
                    spoke_lang_6: e.target.value,
                  });
                }}
                disabled={inputValueChange}
              >
                <option value="">Select One Language</option>
                <option value="Tamil">Tamil</option>
                <option value="Malayalam">Malayalam</option>
                <option value="Kannada">Kannada</option>
                <option value="Telugu">Telugu</option>
                <option value="Marathi">Marathi</option>
                <option value="Hindi">Hindi</option>
                <option value="Urudu">Urudu</option>
                <option value="English">English</option>
              </select>
            </div>
          </div>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Role :</p>
              <strong>{teacher[0].role}</strong>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Comments :</p>
              <strong
              // style={{ width: 175 , overflow: 'hidden'}}
              >
                {/* {teacher[0].note_description} ---
                <ShowFullText title={teacher[0].note_description}>
                  <Typography variant='p' sx={{ cursor: 'pointer' }}>
                    {teacher[0].note_description && teacher[0].note_description.length > 25 ? `${teacher[0].note_description.substring(0, 25)}...` : teacher[0].note_description}
                  </Typography>
                </ShowFullText>
              </strong>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>
                Status <span style={{ color: "red" }}>*</span> :
              </p>

              <select
                // style={{ width: "180px" }}
                value={editedTeacherData.teacher_status}
                onChange={(e) =>
                  setEditedTeacherData({
                    ...editedTeacherData,
                    teacher_status: e.target.value,
                  })
                }
                disabled={inputValueChange}
              >
                {/* <option value="">Select One</option> ---
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
                <option value="drop">Drop</option>
              </select>

              {/* <input
              type="text"
              value={editedTeacherData.teacher_status}
              onChange={(e) =>
                setEditedTeacherData({
                  ...editedTeacherData,
                  teacher_status: e.target.value,
                })
              }
              disabled={inputValueChange}
            /> ---
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Group Status :</p>
              <strong>{teacher[0].group_status}</strong>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Mapped Status :</p>
              <strong>{teacher[0].teacher_mapped_status}</strong>
            </div>

            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "150px" }}>Audio Status :</p>
              <strong>{teacher[0].audio_status}</strong>
            </div>
          </div>
        </div>
      </Tab>

      <Tab eventKey="other" title="Students">
        <div className="d-flex flex-column">
          {/* <div className="d-flex flex-row justify-content-start pt-3 pb-3">
          <div style={{ display: "flex", width: "280px", gap: "20px" }}>
            <p>Batch Id :</p>
            <strong>{teacher[0].group_id}</strong>
          </div>

          <div style={{ display: "flex", width: "280px", gap: "20px"}}>
            <p>Batch Name :</p>
            <strong>{teacher[0].group_name}</strong>
          </div>

          <div style={{ display: "flex", width: "280px", gap: "20px"}}>
            <p>Role :</p>
            <strong>{teacher[0].role}</strong>
          </div>

          <div style={{ display: "flex", width: "280px", gap: "20px"}}>
            <p>Comments :</p>
            <strong>{teacher[0].note_description}</strong>
          </div>

        </div>

        <div className="d-flex flex-row justify-content-start pt-3 pb-3">
          <div style={{ display: "flex", width: "280px", gap: "20px"}}>
            <p>
              Status <span style={{ color: "red" }}>*</span> :
            </p>

            <select
            no need blow style style
              style={{ width: "180px" }} 
              value={editedTeacherData.teacher_status}
              onChange={(e) =>
                setEditedTeacherData({
                  ...editedTeacherData,
                  teacher_status: e.target.value,
                })
              }
              disabled={inputValueChange}
            >
              <option value="">Select One</option>-- no need
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
              <option value="drop">Drop</option>
            </select>
             no need blow one
            <input
              type="text"
              value={editedTeacherData.teacher_status}
              onChange={(e) =>
                setEditedTeacherData({
                  ...editedTeacherData,
                  teacher_status: e.target.value,
                })
              }
              disabled={inputValueChange}
            />
          </div>

          <div style={{ display: "flex", width: "280px", gap: "20px"}}>
            <p>Group Status :</p>
            <strong>{teacher[0].group_status}</strong>
          </div>

          <div style={{ display: "flex", width: "280px", gap: "20px"}}>
            <p>Mapped Status :</p>
            <strong>{teacher[0].teacher_mapped_status}</strong>
          </div>

          <div style={{ display: "flex", width: "280px", gap: "20px"}}>
            <p>Audio Status :</p>
            <strong>{teacher[0].audio_status}</strong>
          </div>
        </div>---

          <div>
            {studentLevelInfo.length > 0 ?
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Mapped To Students</th>
                    <th>Student's level</th>
                  </tr>
                </thead>
                <tbody>
                  {studentLevelInfo.map((levelInfo, index) => {
                    return (
                      <tr key={index}>
                        <td><strong>{levelInfo.student_name}</strong></td>
                        <td>{levelInfo.level_name}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </Table> :
              <p style={{ display: "flex", justifyContent: "center", color: "red", margin: "50px 0" }}>No Mapped to student info for this teacher</p>
            }
          </div>

        </div>
      </Tab>

      {/* Batch tab --

      {/* <Tab eventKey="batch" title="Batch details">
      <div className="d-flex flex-column">

        {teacherBatchListDetails.length > 0 ? 
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Batch id</th>
                <th>Batch name</th>
              </tr>
            </thead>
            <tbody>
              {teacherBatchListDetails.map((batchDetail, index) => {
                return(
                  <tr key={index}>
                    <td><strong>{batchDetail.batch_ids}</strong></td>
                    <td>{batchDetail.batch_name}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table> :
          <p style={{display : "flex", justifyContent: "center", color: "red", margin: "50px 0"}}>No Batch list info for this teacher</p>
        }

      </div>
    </Tab> ---

      {/* Batch tab ends here---
      <Tab eventKey="apr" title="Adarsh Palm Retreat">
        <div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "200px" }}>
              Residing in APR <span style={{ color: "red" }}>*</span>
            </p>

            <select
              type="text"
              style={{ width: "175px" }}
              value={editedTeacherData.is_apr_residing}
              onChange={(e) =>
                setEditedTeacherData({
                  ...editedTeacherData,
                  is_apr_residing: e.target.value === "true",

                  apr_homeaddress: !editedTeacherData.is_apr_residing ? teacher[0].apr_homeaddress : "others",
                  apr_reference_name: editedTeacherData.is_apr_residing ? "" : teacher[0].apr_reference_name,
                  apr_reference_contact: editedTeacherData.is_apr_residing ? "" : teacher[0].apr_reference_contact,
                })
              }
              disabled={inputValueChange}
            >
              <option value="true">Yes</option>
              <option value="false">No</option>
            </select>
          </div>

          <br />

          {editedTeacherData.is_apr_residing && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "200px" }}>
                APR Home Address <span style={{ color: "red" }}>*</span>
              </p>

              <select
                type="text"
                style={{ width: "175px" }}
                value={editedTeacherData.apr_homeaddress}
                onChange={(e) =>
                  setEditedTeacherData({
                    ...editedTeacherData,
                    apr_homeaddress: e.target.value,
                  })
                }
                disabled={inputValueChange}
              >
                <option value="APR Villas">APR Villas</option>
                <option value="APR Towers">APR Towers</option>
              </select>
            </div>
          )}

          {!editedTeacherData.is_apr_residing && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ width: "200px" }}>
                APR Home Address <span style={{ color: "red" }}>*</span>
              </p>

              <select
                type="text"
                style={{ width: "175px" }}
                value={editedTeacherData.apr_homeaddress}
                onChange={(e) =>
                  setEditedTeacherData({
                    ...editedTeacherData,
                    apr_homeaddress: e.target.value,
                  })
                }
                disabled={inputValueChange}
              >
                <option value="others">Others</option>
              </select>
            </div>
          )}

          <br />

          {!editedTeacherData.is_apr_residing && (
            <>
              <div style={{ display: "flex", alignItems: "center" }}>
                <p style={{ width: "200px" }}>APR Reference Name <span style={{ color: "red" }}>*</span></p>

                <input
                  type="text"
                  style={{ width: "175px" }}
                  value={editedTeacherData.apr_reference_name}
                  onChange={(e) => {
                    validateEditedTeacherData(e.target.value, "aprreferencename");
                    setEditedTeacherData({
                      ...editedTeacherData,
                      apr_reference_name: e.target.value,
                    })
                  }}
                  disabled={inputValueChange}
                />
              </div>
              <p style={{ color: "red", marginLeft: "200px" }}>{dataValidate.isRefNameError && "Please enter a valid name"}</p>
            </>
          )}

          <br />

          {!editedTeacherData.is_apr_residing && (
            <>
              <div style={{ display: "flex", alignItems: "center" }}>
                <p style={{ width: "200px" }}>
                  APR Reference Contact{" "}
                  <span style={{ color: "red" }}>*</span>
                </p>

                <input
                  type="text"
                  style={{ width: "175px" }}
                  value={editedTeacherData.apr_reference_contact}
                  onChange={(e) => {
                    validateEditedTeacherData(e.target.value, "aprreferencenumber");
                    setEditedTeacherData({
                      ...editedTeacherData,
                      apr_reference_contact: e.target.value,
                    })
                  }}
                  disabled={inputValueChange}
                />
              </div>
              <p style={{ color: "red", marginLeft: "200px" }}>{dataValidate.isRefNumberError && "Mobile number must contain 10 digit"}</p>
            </>
          )}
        </div>
      </Tab>

      <Tab eventKey="pre_req" title="Other Information">
        <div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "200px" }}>Already Have Student ? :</p>

            <strong>
              {teacher[0].have_student_already === true ? "Yes" : "No"}
            </strong>
          </div>

          <br />

          <div style={{ display: "flex", alignItems: "center" }}>
            <p style={{ width: "200px" }}>
              Tentative Start Date <span style={{ color: "red" }}>*</span>
            </p>

            <input
              type="date"
              style={{ width: "175px" }}
              value={editedTeacherData.tentative_start_date.split("T")[0]}
              onChange={(e) =>
                setEditedTeacherData({
                  ...editedTeacherData,
                  tentative_start_date: e.target.value,
                })
              }
              disabled={inputValueChange}
            />
          </div>
        </div>
      </Tab>

      {/* <Tab eventKey="parent" title="Parent">
      <div>
        <p>
          Parent Name :&nbsp;
          <input type="text" value={teacher[0].parent_name} disabled />
        </p>
        <p>
          Parent Mobile :&nbsp;
          <input
            type="text"
            value={editedTeacherData.parent_contactno}
            onChange={(e) =>
              setEditedTeacherData({
                ...editedTeacherData,
                parent_contactno: e.target.value,
              })
            }
            disabled={inputValueChange}
          />
        </p>
      </div>
    </Tab>---
    </Tabs>
  </Modal.Body>

  <Modal.Footer>
    {buttonValue === false ? (
      <Button variant="primary" onClick={props.onHide}>
        CLOSE
      </Button>
    ) : (
      <div>
        <Button
          type="button"
          variant="light"
          className="mx-3"
          onClick={() => {
            setButtonValue(false);
            setInputValueChange(true);
            props.onHide();
          }}
        >
          CANCEL
        </Button>

        <Button
          type="submit"
          variant="primary"
          disabled={Object.values(dataValidate).some(error => error)}
          onClick={() => putTeacherDataById()}
        >
          SAVE
        </Button>
      </div>
    )}
  </Modal.Footer>
</Modal> }*/

